import './VerticalTable.scss';
import Component from './VerticalTable.js';
export default Component;
